import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=77853e81&scoped=true"
import script from "./HallOfFame.vue?vue&type=script&lang=ts"
export * from "./HallOfFame.vue?vue&type=script&lang=ts"
import style0 from "./HallOfFame.vue?vue&type=style&index=0&id=77853e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77853e81",
  null
  
)

export default component.exports